export const UNIVERSAL_SEARCH_KEY = 'universalSearch';
export const UNIVERSAL_SEARCH_COMPONENT_STATE_KEY = 'componentState';
export const UNIVERSAL_SEARCH_LOCATION_KEY = 'location';
